<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    label: number;
  }>(),
  {
    label: 0,
  },
);
</script>
<template>
  <Transition name="transition-fade">
    <span v-if="props.label" class="badge">{{ props.label }}</span>
  </Transition>
</template>

<style>
.badge {
  font-size: 0.5rem;
  width: 1rem;
  height: 1rem;
  background-color: var(--color-rose-400);
  border: 1px solid var(--color-rose-300);
  border-radius: 100%;
  color: var(--color-slate-50);
  padding: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
</style>
